import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import type React from 'react';

type KeyTechProps = React.ComponentProps<'div'> & { tags: string };

const icons: Record<string, string> = {
	astro: 'lineicons:astro',
	next: 'ri:nextjs-line',
	typescript: 'hugeicons:typescript-01',
	react: 'hugeicons:react',
	tailwind: 'bxl:tailwind-css',
	dashboard: 'mage:dashboard',
};

export function KeyTech({ className, tags, ...props }: KeyTechProps) {
	return (
		<div
			className={cn(
				'contents text-primary *:shrink-0 *:translate-y-2',
				className,
			)}
			{...props}
		>
			{Object.keys(icons).map(
				(key) =>
					tags.includes(key) &&
					icons[key] && (
						<Iconify key={key} className="size-5 lg:size-7" icon={icons[key]} />
					),
			)}
		</div>
	);
}
